import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a5d682e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "issue-comment"
}
const _hoisted_2 = { class: "user-initials" }
const _hoisted_3 = {
  class: "no-mb",
  style: {"font-weight":"500","font-size":"14px"}
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { style: {"margin-right":"16px"} }
const _hoisted_6 = {
  key: 0,
  style: {"margin-right":"16px"}
}
const _hoisted_7 = ["title"]


import Filelist from '@/components/Filelist.vue'
import { ClockCircleOutlined, CheckOutlined } from '@ant-design/icons-vue'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueShowComment',
  props: {
  comment: Object
},
  setup(__props) {

const props = __props;



function readHint (date: string | null) {
  return date ? `Gelezen op ${dayjs(date).format('dddd D MMMM YYYY [om] HH:mm')}` : 'Nog niet gelezen'
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (props.comment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: {span: 0},
              sm: {span: 0},
              md: {span: 0},
              lg: {span: 3}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", null, _toDisplayString(props.comment.user.initials), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              xs: {span: 24},
              sm: {span: 24},
              md: {span: 24},
              lg: {span: 21}
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_3, _toDisplayString(props.comment.user.full_name), 1),
                _createElementVNode("div", {
                  innerHTML: props.comment.body
                }, null, 8, _hoisted_4),
                (props.comment.media.length)
                  ? (_openBlock(), _createBlock(Filelist, {
                      key: 0,
                      media: props.comment.media
                    }, null, 8, ["media"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_unref(ClockCircleOutlined), { style: {"margin-right":"8px"} }),
                  _createTextVNode(_toDisplayString(props.comment.ago), 1)
                ]),
                (props.comment.shared.client)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createTextVNode(" Gedeeld met contactpersoon "),
                      _createElementVNode("span", {
                        class: _normalizeClass({read: props.comment.read_by_client}),
                        title: readHint(props.comment.read_by_client)
                      }, [
                        _createVNode(_unref(CheckOutlined), { class: "send-checkmark" }),
                        (props.comment.read_by_client)
                          ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                              key: 0,
                              class: "read-checkmark"
                            }))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_7)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_divider, { style: {"border-width":"2px"} })
      ]))
    : _createCommentVNode("", true)
}
}

})